'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';

export function safeBack(router, fallbackHref = '/libros') {
  if (
    typeof window !== 'undefined' &&
    window.history.length > 1 &&
    document.referrer &&
    new URL(document.referrer).origin === window.location.origin
  ) {
    router.back();
  } else {
    router.replace(fallbackHref);
  }
}

export default function BackButton({
  className,
  children,
  fallbackHref = '/libros',
}) {
  const { t } = useTranslation();
  const router = useRouter();
  const label = children ?? t("back");

  const handleClick = () => {
    safeBack(router, fallbackHref);
  };

  return (
    <button type="button" className={className} onClick={handleClick}>
      {label}
    </button>
  );
}
